import { Injectable } from '@angular/core';
import { FieldTypes, InputConfig } from '@tmhcc-ng-lib/framwork/form-inputs';
import { Validators } from '@angular/forms';

@Injectable()
export class supportConfigInfo {
  constructor() {}

  quoteInformationConfig = {
    quoteFieldConfig: [
      {
        fieldInfo: {
          fieldName: 'first_name1',
          label: '',
          fieldType: FieldTypes.Text,
          maxChar: 40,
          fieldLength: 40,
          showLabel: true,
          required: true,
          validations: [
            {
              key: 'required',
              value: ''
            }
          ]
        },
        config: {
          validation: [Validators.required],
          isDisabled: false
        }
      },
      {
        fieldInfo: {
          fieldName: 'last_name1',
          label: '',
          fieldType: FieldTypes.Text,
          maxChar: 80,
          fieldLength: 80,
          showLabel: true,
          required: true,
          validations: [
            {
              key: 'required',
              value: ''
            }
          ]
        },
        config: {
          validation: [Validators.required],
          isDisabled: false
        }
      },
      {
        fieldInfo: {
          fieldName: 'company1',
          label: '',
          fieldType: FieldTypes.Text,
          maxChar: 40,
          fieldLength: 40,
          showLabel: true,
          required: true,
          validations: [
            {
              key: 'required',
              value: ''
            }
          ]
        },
        config: {
          validation: [Validators.required],
          isDisabled: false
        }
      },
      {
        fieldInfo: {
          fieldName: 'office_address1',
          label: '',
          fieldType: FieldTypes.Text,
          maxChar: 40,
          fieldLength: 40,
          showLabel: true,
          required: true,
          validations: [
            {
              key: 'required',
              value: ''
            }
          ]
        },
        config: {
          validation: [Validators.required],
          isDisabled: false
        }
      },
      {
        fieldInfo: {
          fieldName: 'city1',
          label: '',
          fieldType: FieldTypes.Text,
          maxChar: 40,
          fieldLength: 40,
          showLabel: true,
          required: true,
          validations: [
            {
              key: 'required',
              value: ''
            }
          ]
        },
        config: {
          validation: [Validators.required],
          isDisabled: false
        }
      },
      {
        fieldInfo: {
          fieldName: 'RequestState1',
          label: '',
          fieldType: FieldTypes.LookupList,
          maxChar: 40,
          fieldLength: 40,
          showLabel: true,
          required: true,
          validations: [
            {
              key: 'required',
              value: ''
            }
          ]
        },
        config: {
          validation: [Validators.required],
          selectConfig: {
            options: [],
            optionConfig: {
              displayKey: 'value',
              search: false,
              limitTo: 3
            },
            multiple: false
          }
        }
      },
      {
        fieldInfo: {
          fieldName: 'zip1',
          label: '',
          fieldType: FieldTypes.Text,
          maxChar: 40,
          fieldLength: 40,
          showLabel: true,
          required: true,
          validations: [
            {
              key: 'required',
              value: ''
            },
          ]
        },
        config: {
          validation: [Validators.required],
          isDisabled: false
        }
      },
      //{
/*         fieldInfo: {
          fieldName: 'phone1',
          label: '',
          fieldType: FieldTypes.Text,
          maxChar: 40,
          fieldLength: 40,
          showLabel: true,
          required: true,
          validations: [
            {
              key: 'required',
              value: ''
            },
          ]
        },
        config: {
          validation: [Validators.required],
          isDisabled: false
        }
      },      
      {
        fieldInfo: {
          fieldName: 'email1',
          label: '',
          fieldType: FieldTypes.Text,
          maxChar: 40,
          fieldLength: 40,
          showLabel: true,
          required: true,
          validations: [
            {
              key: 'required',
              value: ''
            },
          ]
        },
        config: {
          validation: [Validators.required],
          isDisabled: false
        }
      },
 */
      {
        fieldInfo: {
          fieldName: 'business_agreement1',
          label: '',
          fieldType: FieldTypes.Text,
          maxChar: 40,
          fieldLength: 40,
          showLabel: true,
          required: true,
},
        config: {
          isDisabled: false
        }
      }
    ]
  };
  phoneRequestForm = {
    phoneRequestFieldConfig: [
      {
        fieldInfo: {
          fieldName: 'phone1',
          label: '',
          maxChar: 10,
          minlength: 10,
          fieldLength: 10,
          fieldType: FieldTypes.Numeric,
          showLabel: true,
          required: true,
          validations: [
            {
              key: 'required',
              value: ''
            },
            {
              key: 'minlength',
              value: 'Please enter atleast 10 digits'
            }
          ]
        },

        config: {
          validation: [Validators.required, Validators.minLength(10)],

          isDisabled: false,

          numericConfig: {
            type: 'phone'
          }
        }
      }
    ]
  };
  emailRequestForm = {
    emailRequestFieldConfig: [
      {
        fieldInfo: {
          fieldName: 'email1',
          feildEmailInfo: 'email1',
          label: '',
          fieldType: FieldTypes.Email,
          maxChar: 80,
          fieldLength: 80,
          showLabel: true,
          required: true,
          validations: [
            {
              key: 'required',
              value: ''
            },
            {
              key: 'pattern',
              value: 'Please enter a valid email address'
            }
          ]
        },
        config: {
          validation: [Validators.required],
          isDisabled: false
        }
      }
    ]
  }

  supportRequestProducts = {
    supportRequestProductsFieldConfig: [
      {
        fieldInfo: {
          fieldName: '00N6g00000TXa0v',
          label: '',
          fieldType: FieldTypes.Checkbox,
          showLabel: true
        },
        config: {}
      },
      {
        fieldInfo: {
          fieldName: '00N6g00000TXa0v1',
          label: '',
          fieldType: FieldTypes.Checkbox,
          showLabel: true
        },
        config: {}
      },
      {
        fieldInfo: {
          fieldName: '00N6g00000TXa0v2',
          label: '',
          fieldType: FieldTypes.Checkbox,
          showLabel: true
        },
        config: {}
      },
      // {
      //   fieldInfo: {
      //     fieldName: '00N6g00000TXa0v3',
      //     label: '',
      //     fieldType: FieldTypes.Checkbox,
      //     showLabel: true
      //   },
      //   config: {}
      // },
      {
        fieldInfo: {
          fieldName: '00N6g00000TXa0v4',
          label: '',
          fieldType: FieldTypes.Checkbox,
          showLabel: true
        },
        config: {}
      },
      {
        fieldInfo: {
          fieldName: '00N6g00000TXa0v5',
          label: '',
          fieldType: FieldTypes.Checkbox,
          showLabel: true
        },
        config: {}
      }
    ]
  };
/*   companyRequest = {
    companyRequestFieldConfig: [
      {
        fieldInfo: {
          fieldName: '00N6g00000TXa98',
          label: 'companyRequest',
          fieldType: FieldTypes.Text,
          showLabel: false
        },
        config: {}
      }
    ]
  };
 */  
premiumProducts = {
    premiumFieldConfig: [
      {
        fieldInfo: {
          fieldName: '00N6g00000TXa9h',
          label: 'radio',
          fieldType: FieldTypes.Radio,
          showLabel: true,
          required: true,
          validations: [
            {
              key: 'required',
              value: 'Company is required'
            }
          ]
        },
        config: {
          validation: [Validators.required],
          isDisabled: false,
          radioCofig: {
            radioGroup: [
              {
                label: '$50,000-$100,000',
                value: '$50,000-$100,000',
                style: 'pl-0 float-left'
              },
              {
                label: '$100,001-$250,000',
                value: '$100,001-$250,000',
                style: 'pl-0 float-left'
              },
              {
                label: '$250,001-$500,000',
                value: '$250,001-$500,000',
                style: 'pl-0 float-left'
              },

              {
                label: '$500,001-$1,000,000',
                value: '$500,001-$1,000,000',
                style: 'pl-0 float-left'
              },

              {
                label: 'Over $1,000,000',
                value: 'Over $1,000,000',
                style: 'pl-0 float-left'
              }
            ]
          }
        }
      }
    ]
  };
  cn = {
    oid: '',
    retURL: '',
    lead_source: '',
    debug: '',
    debugEmail: '',
    first_name: '',
    last_name: '',
    company: '',
    office_address: '',
    city: '',
    RequestState: '',
    zip:'',
    phone: '',
    email: '',
    access_request_origination: '',
    business_agreement:''
  };
}
